module.exports = __webpack_public_path__ + "img/yxl-ensure.c62809eb.png";